import { render, staticRenderFns } from "./details-right-task.vue?vue&type=template&id=2179bcb8&scoped=true&"
import script from "./details-right-task.vue?vue&type=script&lang=ts&"
export * from "./details-right-task.vue?vue&type=script&lang=ts&"
import style0 from "./details-right-task.vue?vue&type=style&index=0&id=2179bcb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2179bcb8",
  null
  
)

export default component.exports